<template>
    <div class="sp-phone-wrapper sp-reveal sp-reveal--zoom">
        <!-- Badges flotantes decorativos con métricas en tiempo real -->
        <div class="sp-floating-badge sp-floating-badge--top">
            <span class="sp-floating-badge__dot"></span>
            <div>
                <strong>+14,200</strong>
                <span>Conductores en ruta hoy</span>
            </div>
        </div>

        <div class="sp-floating-badge sp-floating-badge--bottom">
            <i class="pi pi-bolt sp-floating-badge__icon" aria-hidden="true"></i>
            <div>
                <strong>98.6%</strong>
                <span>Impacto en geocerca</span>
            </div>
        </div>

        <figure class="sp-phone-figure">
            <div class="sp-phone" aria-label="Demostración de la app Seway Plus para conductores">
                <div class="sp-phone__screen">
                    <div class="sp-phone__island"></div>

                    <!-- Barra de estado -->
                    <div class="sp-phone__status">
                        <span class="sp-phone__hora">10:30</span>
                        <span class="sp-phone__status-icons">
                            <i class="pi pi-wifi"></i>
                            <span class="sp-phone__bateria"></span>
                        </span>
                    </div>

                    <!-- App Bar -->
                    <div class="sp-phone__appbar">
                        <img src="layout/images/seway-blanco.png" alt="Seway" class="sp-phone__logo" />
                        <div class="sp-phone__appbar-actions">
                            <span class="sp-phone__notif-badge"></span>
                            <i class="pi pi-bell"></i>
                        </div>
                    </div>

                    <!-- Cuerpo de la app -->
                    <div class="sp-phone__body">
                        <div class="sp-phone__header-row">
                            <div>
                                <p class="sp-phone__saludo">¡Buen día, Conductor!</p>
                                <p class="sp-phone__sub">Ofertas cerca de tu ruta activa</p>
                            </div>
                            <span class="sp-phone__gps-pill">
                                <i class="pi pi-compass"></i> GPS Activo
                            </span>
                        </div>

                        <!-- Mapa interactivo animado -->
                        <div class="sp-phone__mapa">
                            <svg viewBox="0 0 300 155" preserveAspectRatio="xMidYMid slice" role="presentation" focusable="false">
                                <rect width="300" height="155" fill="#0f1f2a" />
                                
                                <!-- Red de carreteras secundarias -->
                                <path d="M-10 132 L120 118 L200 96 L310 88" stroke="#1c3342" stroke-width="10" fill="none" stroke-linecap="round" />
                                <path d="M46 -10 L60 62 L96 118 L104 180" stroke="#1c3342" stroke-width="8" fill="none" stroke-linecap="round" />
                                <path d="M228 -10 L236 54 L214 104 L250 180" stroke="#1c3342" stroke-width="8" fill="none" stroke-linecap="round" />
                                <path d="M-10 44 L88 38 L168 52 L310 32" stroke="#162936" stroke-width="6" fill="none" stroke-linecap="round" />

                                <!-- Geocerca de cobertura del comercio -->
                                <circle cx="138" cy="84" r="32" fill="rgba(235, 93, 27, 0.12)" stroke="#EB5D1B" stroke-width="1" stroke-dasharray="3 3" />
                                <circle cx="226" cy="42" r="28" fill="rgba(47, 128, 237, 0.1)" stroke="#2F80ED" stroke-width="1" stroke-dasharray="3 3" />

                                <!-- Ruta activa del conductor con efecto neón animado -->
                                <path
                                    d="M48 138 C 90 132, 108 112, 138 88 C 172 65, 192 52, 236 42"
                                    stroke="rgba(235, 93, 27, 0.3)"
                                    stroke-width="9"
                                    fill="none"
                                    stroke-linecap="round"
                                />
                                <path
                                    class="sp-phone__route-glow"
                                    d="M48 138 C 90 132, 108 112, 138 88 C 172 65, 192 52, 236 42"
                                    stroke="#EB5D1B"
                                    stroke-width="4.5"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />

                                <!-- Pines de comercios aliados -->
                                <g transform="translate(138 72)" class="sp-phone__pin" :class="{ 'is-selected': ofertaActiva === 0 }">
                                    <path d="M0 16 C -7 6, -10 2, -10 -2 A 10 10 0 1 1 10 -2 C 10 2, 7 6, 0 16 Z" fill="#ffffff" />
                                    <circle cx="0" cy="-2" r="4" fill="#EB5D1B" />
                                </g>
                                <g transform="translate(226 28)" class="sp-phone__pin" :class="{ 'is-selected': ofertaActiva === 1 }">
                                    <path d="M0 16 C -7 6, -10 2, -10 -2 A 10 10 0 1 1 10 -2 C 10 2, 7 6, 0 16 Z" fill="#EB5D1B" />
                                    <circle cx="0" cy="-2" r="4" fill="#ffffff" />
                                </g>

                                <!-- Posición del conductor con ondas de pulso -->
                                <circle class="sp-phone__pulse-wave" cx="48" cy="138" r="14" fill="#2f80ed" />
                                <circle cx="48" cy="138" r="6" fill="#2f80ed" stroke="#fff" stroke-width="2.5" />
                            </svg>
                            <span class="sp-phone__mapa-tag">
                                <i class="pi pi-map-marker"></i> En ruta • Vía Nacional
                            </span>
                        </div>

                        <!-- Carrusel de ofertas dinámicas -->
                        <transition name="sp-fade-slide" mode="out-in">
                            <div :key="ofertaActiva" class="sp-phone__oferta">
                                <div class="sp-phone__oferta-img">
                                    <img :src="ofertaActual.img" :alt="ofertaActual.negocio" />
                                    <span class="sp-phone__badge">{{ ofertaActual.badge }}</span>
                                    <span class="sp-phone__dist-pill">
                                        <i class="pi pi-map-marker"></i> {{ ofertaActual.distancia }}
                                    </span>
                                </div>
                                <div class="sp-phone__oferta-txt">
                                    <div class="sp-phone__oferta-header">
                                        <p class="sp-phone__oferta-titulo">{{ ofertaActual.titulo }}</p>
                                    </div>
                                    <p class="sp-phone__oferta-negocio">
                                        <i class="pi pi-building"></i> {{ ofertaActual.negocio }}
                                    </p>
                                    <button type="button" class="sp-phone__oferta-btn">
                                        <span>Cómo llegar</span>
                                        <i class="pi pi-arrow-right"></i>
                                    </button>
                                </div>
                            </div>
                        </transition>

                        <!-- Indicadores de slide -->
                        <div class="sp-phone__dots">
                            <button
                                v-for="(oferta, index) in ofertas"
                                :key="index"
                                type="button"
                                :class="{ 'is-active': ofertaActiva === index }"
                                :aria-label="'Ver oferta ' + (index + 1)"
                                @click="seleccionarOferta(index)"
                            ></button>
                        </div>
                    </div>

                    <!-- Pestañas inferiores -->
                    <nav class="sp-phone__tabs">
                        <span><i class="pi pi-home"></i>Inicio</span>
                        <span><i class="pi pi-directions"></i>Ruta</span>
                        <span class="is-active"><i class="pi pi-tag"></i>Ofertas</span>
                        <span><i class="pi pi-comments"></i>Mensajes</span>
                        <span><i class="pi pi-user"></i>Perfil</span>
                    </nav>
                </div>
            </div>

            <figcaption class="sp-phone-caption">
                <i class="pi pi-info-circle"></i> Visualización de tu anuncio en la app de conductores
            </figcaption>
        </figure>
    </div>
</template>

<script>
export default {
    name: 'PhoneMockup',
    data() {
        return {
            ofertaActiva: 0,
            intervalo: null,
            ofertas: [
                {
                    badge: 'DESTACADO',
                    titulo: '15% de descuento en almuerzo ejecutivo',
                    negocio: 'Restaurante Doña María',
                    distancia: 'A 1,2 km de tu ruta',
                    img: 'layout/images/negocios/almuerzo.webp'
                },
                {
                    badge: 'RECOMENDADO',
                    titulo: 'Noche de descanso + Parqueadero gratis',
                    negocio: 'Hotel & Parador Ruta del Sol',
                    distancia: 'A 2,4 km de tu ruta',
                    img: 'layout/images/negocios/hotel.webp'
                },
                {
                    badge: '24 HORAS',
                    titulo: 'Revisión y calibración rápida de llantas',
                    negocio: 'Montallantas El Paisa',
                    distancia: 'A 800 m de tu ruta',
                    img: 'layout/images/negocios/montallantas.webp'
                }
            ]
        };
    },
    computed: {
        ofertaActual() {
            return this.ofertas[this.ofertaActiva];
        }
    },
    mounted() {
        this.iniciarRotacion();
    },
    beforeUnmount() {
        this.detenerRotacion();
    },
    methods: {
        iniciarRotacion() {
            this.detenerRotacion();
            this.intervalo = setInterval(() => {
                this.ofertaActiva = (this.ofertaActiva + 1) % this.ofertas.length;
            }, 4600);
        },
        detenerRotacion() {
            if (this.intervalo) {
                clearInterval(this.intervalo);
                this.intervalo = null;
            }
        },
        seleccionarOferta(index) {
            this.ofertaActiva = index;
            this.iniciarRotacion(); // Reinicia el temporizador
        }
    }
};
</script>

<style lang="scss" scoped>
.sp-phone-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 440px;
    margin: 0 auto;
}

/* Badges flotantes decorativos */
.sp-floating-badge {
    position: absolute;
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.65rem 1.1rem;
    background: rgba(13, 48, 68, 0.9);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 14px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
    color: #fff;
    pointer-events: none;
    animation: sp-float-y 5s ease-in-out infinite;

    strong {
        display: block;
        font-size: 0.95rem;
        font-weight: 800;
        color: #fff;
        line-height: 1.1;
    }

    span {
        font-size: 0.75rem;
        color: var(--sp-text-on-dark-soft);
    }
}

.sp-floating-badge--top {
    top: 8%;
    right: -6%;
    animation-delay: -1s;
}

.sp-floating-badge--bottom {
    bottom: 12%;
    left: -8%;
    animation-delay: -2.5s;
}

.sp-floating-badge__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #22c55e;
    box-shadow: 0 0 10px #22c55e;
    animation: sp-pulse-glow 2s infinite;
}

.sp-floating-badge__icon {
    font-size: 1.2rem;
    color: var(--sp-orange);
}

.sp-phone {
    position: relative;
    font-size: clamp(10px, 1.15vw, 13px);
    width: 25.5em;
    max-width: 100%;
    margin: 0 auto;
    padding: 0.85em;
    background: linear-gradient(150deg, #485c6c, #1a2731 45%, #425360);
    border-radius: 3.6em;
    box-shadow: 0 25px 60px rgba(8, 31, 45, 0.45), 0 0 0 1px rgba(255, 255, 255, 0.12);
    animation: sp-float-y 6s ease-in-out infinite;
}

.sp-phone__screen {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #0f1c25;
    border-radius: 3em;
    color: #fff;
    box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.6);
}

.sp-phone__island {
    position: absolute;
    top: 0.75em;
    left: 50%;
    transform: translateX(-50%);
    width: 7.5em;
    height: 1.85em;
    background: #04080b;
    border-radius: 1em;
    z-index: 5;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
}

.sp-phone__status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.9em 1.6em 0.35em;
    background: var(--sp-navy);
    font-size: 0.92em;
    font-weight: 600;
}

.sp-phone__status-icons {
    display: inline-flex;
    align-items: center;
    gap: 0.5em;
    font-size: 0.85em;
}

.sp-phone__bateria {
    display: inline-block;
    width: 1.9em;
    height: 0.95em;
    border: 0.14em solid rgba(255, 255, 255, 0.8);
    border-radius: 0.28em;
    background: linear-gradient(to right, #22c55e 85%, transparent 85%);
    background-clip: content-box;
    padding: 0.1em;
}

.sp-phone__appbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4em 1.4em 0.9em;
    background: var(--sp-navy);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.sp-phone__logo {
    height: 1.85em;
    width: auto;
}

.sp-phone__appbar-actions {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 1.1em;
}

.sp-phone__notif-badge {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--sp-orange);
}

.sp-phone__body {
    padding: 1em 1.15em 0.7em;
    background: #0d1a24;
}

.sp-phone__header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.sp-phone__saludo {
    font-size: 1.25em;
    font-weight: 800;
    letter-spacing: -0.01em;
}

.sp-phone__sub {
    margin-top: 0.15em;
    color: rgba(255, 255, 255, 0.65);
    font-size: 0.92em;
}

.sp-phone__gps-pill {
    display: inline-flex;
    align-items: center;
    gap: 0.35em;
    padding: 0.25em 0.6em;
    background: rgba(34, 197, 94, 0.15);
    border: 1px solid rgba(34, 197, 94, 0.3);
    border-radius: 999px;
    color: #4ade80;
    font-size: 0.72em;
    font-weight: 700;
}

.sp-phone__mapa {
    position: relative;
    margin-top: 0.8em;
    overflow: hidden;
    border-radius: 1.1em;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
    line-height: 0;

    svg {
        display: block;
        width: 100%;
        height: auto;
    }
}

.sp-phone__route-glow {
    stroke-dasharray: 8 5;
    animation: sp-dash-flow 1.8s linear infinite;
}

.sp-phone__pulse-wave {
    animation: sp-pulse-beacon 2.4s ease-out infinite;
}

.sp-phone__mapa-tag {
    position: absolute;
    left: 0.65em;
    bottom: 0.65em;
    display: inline-flex;
    align-items: center;
    gap: 0.35em;
    padding: 0.3em 0.75em;
    background: rgba(8, 31, 45, 0.85);
    backdrop-filter: blur(6px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 999px;
    color: #fff;
    font-size: 0.75em;
    font-weight: 600;
    line-height: 1.5;

    i {
        color: var(--sp-orange);
    }
}

.sp-phone__oferta {
    margin-top: 0.85em;
    overflow: hidden;
    background: #ffffff;
    border-radius: 1.1em;
    color: var(--sp-navy);
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.28);
}

.sp-phone__oferta-img {
    position: relative;
    aspect-ratio: 16 / 9;
    line-height: 0;
    background: #e2e8f0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.sp-phone__badge {
    position: absolute;
    top: 0.6em;
    left: 0.6em;
    padding: 0.28em 0.7em;
    background: linear-gradient(135deg, var(--sp-orange) 0%, #ff7536 100%);
    border-radius: 999px;
    color: #fff;
    font-size: 0.7em;
    font-weight: 800;
    letter-spacing: 0.05em;
    line-height: 1.5;
    box-shadow: 0 2px 8px rgba(235, 93, 27, 0.5);
}

.sp-phone__dist-pill {
    position: absolute;
    bottom: 0.6em;
    right: 0.6em;
    padding: 0.25em 0.65em;
    background: rgba(8, 31, 45, 0.85);
    backdrop-filter: blur(4px);
    border-radius: 999px;
    color: #fff;
    font-size: 0.7em;
    font-weight: 600;
    line-height: 1.5;

    i {
        color: var(--sp-orange);
    }
}

.sp-phone__oferta-txt {
    padding: 0.8em 0.95em 0.95em;
}

.sp-phone__oferta-titulo {
    font-size: 1.05em;
    font-weight: 800;
    line-height: 1.25;
    color: var(--sp-navy);
}

.sp-phone__oferta-negocio {
    display: flex;
    align-items: center;
    gap: 0.35em;
    margin-top: 0.25em;
    color: #4a5f6d;
    font-size: 0.88em;
    font-weight: 600;

    i {
        color: var(--sp-orange);
    }
}

.sp-phone__oferta-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5em;
    width: 100%;
    margin-top: 0.75em;
    padding: 0.6em;
    background: linear-gradient(135deg, var(--sp-navy) 0%, var(--sp-navy-800) 100%);
    border: 0;
    border-radius: 0.65em;
    color: #fff;
    font-size: 0.9em;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
        background: var(--sp-orange);
    }
}

.sp-phone__dots {
    display: flex;
    justify-content: center;
    gap: 0.45em;
    padding: 0.75em 0 0.25em;

    button {
        width: 0.45em;
        height: 0.45em;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.25);
        cursor: pointer;
        transition: all 0.25s ease;

        &.is-active {
            width: 1.4em;
            border-radius: 999px;
            background: var(--sp-orange);
            box-shadow: 0 0 8px rgba(235, 93, 27, 0.6);
        }
    }
}

.sp-phone__tabs {
    display: flex;
    justify-content: space-between;
    padding: 0.65em 1em 1.35em;
    background: #060e14;
    border-top: 1px solid rgba(255, 255, 255, 0.06);

    span {
        display: flex;
        flex: 1 1 0;
        flex-direction: column;
        align-items: center;
        gap: 0.25em;
        color: rgba(255, 255, 255, 0.45);
        font-size: 0.7em;
        font-weight: 600;
        text-align: center;
    }

    i {
        font-size: 1.3em;
    }

    .is-active {
        color: var(--sp-orange);
    }
}

.sp-phone-figure {
    margin: 0;
}

.sp-phone-caption {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4em;
    margin-top: 1.15rem;
    color: var(--sp-text-soft);
    font-size: 0.8rem;
    text-align: center;

    i {
        color: var(--sp-orange);
    }
}

/* Transiciones entre ofertas */
.sp-fade-slide-enter-active,
.sp-fade-slide-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.sp-fade-slide-enter-from {
    opacity: 0;
    transform: translateX(14px);
}

.sp-fade-slide-leave-to {
    opacity: 0;
    transform: translateX(-14px);
}

@media (max-width: 991px) {
    .sp-floating-badge {
        display: none; // Evita solapamiento en pantallas estrechas
    }

    .sp-phone {
        font-size: clamp(10px, 3vw, 13.5px);
    }
}
</style>
